module.exports = __webpack_public_path__ + "c21866a957e97f5efc5eca407d54e1f0.MP3";